import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { CustomerInfoComponent } from '../customer.info.component';
import { Customer } from '../../../shared/models/customer.interface';

@Component({
  selector: 'app-customer-info-desktop',
  templateUrl: './customer-info-desktop.component.html',
  styleUrls: ['./customer-info-desktop.component.scss']
})
export class CustomerInfoDesktopComponent extends CustomerInfoComponent implements OnInit {
  @Input()
  public set customerObject(value: Customer) {
    if (value) {
      // clone object to keep changes local
      let customer = (<any>Object).assign({}, value) as Customer;
      this.loadCustomer(customer);
    }
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

}
